
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getAddPhoneToContactDtoFormGroup() {
return new FormGroup({
    contactPersonId: new FormControl<number | undefined>(undefined),
    value: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(45)]),
    note: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    phonetypeId: new FormControl<number | undefined>(undefined, [Validators.required]),
    standard: new FormControl<boolean | undefined>(false, [requiredBoolean()]),
    canLogin: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
})
;
}
      